/**
 * The one job-search-status vocabulary.
 *
 * `value` is the token the account endpoint stores and validates as an enum, so it is never
 * rendered — "Open for Reach outs" is a database value, not a sentence. Every surface shows
 * `label` instead, which is what stops the nav badge, the preferences modal and the profile card
 * from calling the same saved status three different things.
 */
export type JobSearchStatusTone = "positive" | "caution" | "neutral";

export interface JobSearchStatusOption {
	/** Persisted verbatim. Changing one breaks every account already holding it. */
	value: string;
	label: string;
	description: string;
	tone: JobSearchStatusTone;
	/** Bootstrap icon class, read by the older /jobs preference screens. */
	classIcon: string;
}

export const jobSearchStatusOptions: JobSearchStatusOption[] = [
	{
		value: "Actively Looking",
		label: "Open to opportunities",
		description: "Interested in new roles.",
		tone: "positive",
		classIcon: "fa fa-check-circle text-success",
	},
	{
		value: "Open for Reach outs",
		label: "Open to offers",
		description: "Not actively seeking, but open to contact.",
		tone: "caution",
		classIcon: "fa fa-clock-o text-warning",
	},
	{
		value: "Not Looking",
		label: "Not looking",
		description: "Not open to new opportunities.",
		tone: "neutral",
		classIcon: "fa fa-times-circle text-danger",
	},
];

export function findJobSearchStatus(value?: string): JobSearchStatusOption | undefined {
	return jobSearchStatusOptions.find((option) => option.value === value);
}

/** The friendly name for a stored status, or "" when nothing is set. */
export function jobSearchStatusLabel(value?: string): string {
	return findJobSearchStatus(value)?.label ?? "";
}
